import { FeatureFlagName } from '@/features'
import { AppFaIcons } from '@/icons-injection'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { ParkMode } from 'rikroot-types/parksmanagement/settings.pb'
import { i18n } from '@/i18n'

Vue.use(VueRouter)

export type TRouteMeta = {
  title?: string
  icon?: string[]
  customIcon?: string
  layout: string
  allowedRouts?: string[]
  visible?: boolean | (() => boolean)
  devFlag?: FeatureFlagName
  disabled?: boolean
  parkMode?: ParkMode
}

export type TRouteConfig = {
  path: string
  name: string
  redirect?: any
  title?: string
  component?: any
  meta: TRouteMeta
  children?: TRouteConfig[]
}

export const routes: TRouteConfig[] = [
  {
    path: '',
    name: 'dashboard.layout',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      layout: 'main-layout',
    },
    children: [
      // {
      //   path: '/',
      //   name: 'dashboard',
      //   component: () => import(/* webpackChunkName: "dashboard"  */ '@/views/dashboard/index.vue'),
      //   meta: {
      //     title: 'Дашборд | Сводка',
      //     icon: ['fas', 'chart-area'],
      //     layout: 'main-layout',
      //     devFlag: 'dashboard'
      //   }
      // },
      {
        path: '/',
        name: 'dashboard',
        component: () =>
          import(
            /* webpackChunkName: "dashboardV2"  */ '@/modules/dashboard/views/DashboardView.vue'
          ),
        meta: {
          title: 'Дашборд | Сводка',
          icon: ['fas', 'chart-area'],
          layout: 'main-layout',
          devFlag: 'dashboardV2',
        },
      },
    ],
  },
  {
    path: '',
    name: 'tenants.layout',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      layout: 'main-layout',
    },
    children: [
      // {
      //   path: '/tenantsIncome',
      //   name: 'tenantsIncome',
      //   component: () => import(/* webpackChunkName: "tenantsIncome"  */ '@/views/tenantsIncome/index.vue'),
      //   meta: {
      //     title: 'Бухгалтерия | Расчет',
      //     customIcon: 'coins.svg',
      //     layout: 'main-layout',
      //     devFlag: 'tenantsIncome'
      //   }
      //
      // },
      {
        path: '/tenantsIncomeV2',
        name: 'TenantsIncomeV2',
        component: () =>
          import(
            /* webpackChunkName: "tenantsIncome"  */ '@/modules/tenantsIncome/views/TenantsIncomePage.vue'
          ),
        meta: {
          title: 'Бухгалтерия | Расчет V2',
          customIcon: 'coins.svg',
          layout: 'main-layout',
          devFlag: 'tenantsIncomeV2',
        },
      },
      {
        path: '/accounting',
        name: 'accounting',
        component: () =>
          import(
            /* webpackChunkName: "Accounting"  */ '@/modules/accounting/views/AccountingView.vue'
          ),
        meta: {
          title: i18n.t('accounting.withdrawals.title').toString(),
          customIcon: 'coins.svg',
          layout: 'main-layout',
          devFlag: 'accounting',
        },
      },
      {
        path: '/accounting-settings',
        name: 'accountingSettings',
        component: () =>
          import(
            /* webpackChunkName: "Accounting"  */ '@/modules/accounting/views/AccountingSettingsView.vue'
          ),
        meta: {
          title: i18n.t('accounting.settings.title').toString(),
          customIcon: 'coins.svg',
          layout: 'main-layout',
          devFlag: 'accounting',
        },
      },
      {
        path: '/accounting-dashboard',
        name: 'accountingDashboard',
        component: () =>
          import(
            /* webpackChunkName: "Accounting"  */ '@/modules/accounting/views/AccountingDashboardView.vue'
          ),
        meta: {
          title: i18n.t('accounting.dashboard.title').toString(),
          customIcon: 'coins.svg',
          layout: 'main-layout',
          devFlag: 'accounting',
        },
      },
    ],
  },
  {
    path: '/shedule',
    name: 'schedule',
    redirect: { name: 'ScheduleV2' },
    component: () => import(/* webpackChunkName: "shedule"  */ '@/views/shedule/index.vue'),
    meta: {
      title: 'Смены',
      icon: ['fas', 'calendar-alt'],
      layout: 'main-layout',
      devFlag: 'schedule',
    },
  },
  // {
  //   path: '',
  //   name: 'fines.layout',
  //   // redirect: { name: 'parts.storage-table' },
  //   // component: () => import(/* webpackChunkName: "parts"  */ '@/views/fines/layout.vue'),
  //   component: () => import(/* webpackChunkName: "parts"  */ '@/modules/fines/views/FinesLayout.vue'),
  //   meta: {
  //     title: 'Штрафы',
  //     customIcon: 'cvtv.svg',
  //     layout: 'mainLayout'
  //   },
  //   children: [
  //     {
  //       path: '/fines',
  //       name: 'fines',
  //       meta: {
  //         title: 'Штрафы',
  //         customIcon: 'cvtv.svg',
  //         layout: 'mainLayout',
  //         devFlag: 'fines'
  //       },
  //       component: () => import(/* webpackChunkName: "FinesView"  */ '@/modules/fines/views/FinesView.vue')
  //     },
  //     {
  //       path: '/fines/history',
  //       name: 'fines.history',
  //       meta: {
  //         title: 'Штрафы | История',
  //         customIcon: 'cvtv.svg',
  //         layout: 'mainLayout',
  //         devFlag: 'finesHistory'
  //       },
  //       component: () => import(/* webpackChunkName: "FinesHistoryView"  */ '@/modules/fines/views/FinesHistoryView.vue')
  //     },
  //     {
  //       path: '/fines/archive',
  //       name: 'fines.archive',
  //       meta: {
  //         title: 'Штрафы | Удаленные',
  //         customIcon: 'cvtv.svg',
  //         layout: 'mainLayout',
  //         devFlag: 'finesArchive'
  //       },
  //       component: () => import(/* webpackChunkName: "FinesArchive"  */ '@/modules/fines/views/FinesArchive.vue')
  //     }
  //   ]
  // },
  {
    path: '',
    name: 'fiscal-receipts.layout',
    component: () =>
      import(
        /* webpackChunkName: "fiscalReceipts"  */ '@/modules/fiscalReceipts/views/FiscalReceiptsLayout.vue'
      ),
    meta: {
      layout: 'main-layout',
      title: 'Фискальные чеки',
    },
    children: [
      {
        path: '/fiscal-receipts',
        name: 'FiscalReceipts',
        meta: {
          icon: ['fas', 'receipt'],
          layout: 'mainLayout',
          devFlag: 'fiscalReceipts',
          title: i18n.t('fiscal_receipts').toString(),
        },
        component: () =>
          import(
            /* webpackChunkName: "fiscalReceipts"  */ '@/modules/fiscalReceipts/views/FiscalReceiptsView.vue'
          ),
      },
      {
        path: '/fiscal-receipts/generation',
        name: 'FiscalReceiptsGeneration',
        meta: {
          title: i18n.t('fiscal_receipts.geeneration').toString(),
          icon: ['fas', 'receipt'],
          layout: 'mainLayout',
          devFlag: 'fiscalReceiptsGeneration',
        },
        component: () =>
          import(
            /* webpackChunkName: "fiscalReceiptsGeneration"  */ '@/modules/fiscalReceipts/views/FiscalReceiptsGenerationView.vue'
          ),
      },
      {
        path: '/fiscal-receipts/settings',
        name: 'FiscalReceiptsSettings',
        meta: {
          title: i18n.t('fiscal_receipts.settings').toString(),
          icon: ['fas', 'receipt'],
          layout: 'mainLayout',
          devFlag: 'fiscalReceiptsSettings',
        },
        component: () =>
          import(
            /* webpackChunkName: "fiscalReceiptsGeneration"  */ '@/modules/fiscalReceipts/views/FiscalReceiptsSettingsView.vue'
          ),
      },
    ],
  },
  {
    path: '/scheduleV2',
    name: 'ScheduleV2',
    component: () =>
      import(/* webpackChunkName: "sheduleV2"  */ '@/modules/schedule/views/SchedulePage.vue'),
    meta: {
      title: 'Аренды',
      icon: ['fas', 'calendar-alt'],
      layout: 'main-layout',
      devFlag: 'scheduleV2',
    },
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    name: 'Reports',
    meta: {
      title: 'Арендаторы',
      icon: ['fas', 'chart-pie'],
      layout: 'main-layout',
    },
    children: [
      {
        path: '/report/driverOutflow',
        component: () => import('@/modules/driverOutflow/views/DriverOutflowPage.vue'),
        name: 'DriverOutflow',
        meta: {
          title: 'Отчет по оттоку',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout',
          devFlag: 'driverOutflow',
        },
      },
      {
        path: '/report/consolidated',
        component: () =>
          import(
            /* webpackChunkName: "consolidatedReport"  */ '@/views/consolidatedReport/index.vue'
          ),
        name: 'ReportConsolidated',
        meta: {
          title: 'Ежемесячный отчет',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout',
          devFlag: 'reportConsolidated',
        },
      },
      {
        path: '/report/techInspectionReport',
        component: () =>
          import(
            /* webpackChunkName: "techInspectionReport"  */ '@/views/techInspectionReport/index.vue'
          ),
        name: 'ReportTechInspectionReport',
        meta: {
          title: 'Ежемесячный отчет по Т.О.',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout',
          devFlag: 'reportTechInspectionReport',
        },
      },
      {
        path: '/report/carReport',
        component: () =>
          import(
            /* webpackChunkName: "CarReportView"  */ '@/modules/reports/views/CarReportView.vue'
          ),
        name: 'CarReport',
        meta: {
          title: 'Отчет по авто',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout',
          devFlag: 'carReport',
        },
      },
      {
        path: '/report/transaction',
        component: () =>
          import(
            /* webpackChunkName: "CarReportView"  */ '@/modules/transactionReports/views/TransactionReportPage.vue'
          ),
        name: 'TransactionReport',
        meta: {
          title: 'Транзакционный отчет',
          icon: ['fas', 'chart-pie'],
          layout: 'main-layout',
          devFlag: 'transactionReport',
        },
      },
    ],
  },
  {
    path: '',
    name: 'Tenants',
    meta: {
      title: 'Арендаторы',
      customIcon: 'users.svg',
      layout: 'main-layout',
    },
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    children: [
      {
        path: '/tenantsInfo',
        name: 'TenantsInfo',
        component: () =>
          import(
            /* webpackChunkName: "tenantsInfo"  */ '@/modules/tenantsInfo/views/TenantsPage.vue'
          ),
        meta: {
          title: i18n.t('drivers.title').toString(),
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'tenantsInfo',
        },
      },
      {
        path: '/debtors_by_balances',
        name: 'TenantsInfo.debtors_by_balances',
        component: () =>
          import(
            /* webpackChunkName: "tenantsInfo"  */ '@/views/tenantsInfo/debtorsByBalances.vue'
          ),
        meta: {
          title: 'Задолженности',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'debtorsByBalances',
        },
      },
      {
        path: '/driver_deposit_debts',
        name: 'TenantsInfo.driver_deposit_debts',
        component: () =>
          import(/* webpackChunkName: "tenantsInfo"  */ '@/views/tenantsInfo/debtorsByDebts.vue'),
        meta: {
          title: 'Реестр по депозитам',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'driverDepositDebts',
        },
      },
      {
        name: 'TenantsCandidatesInfo',
        path: '/tenantsCandidatesInfo',
        component: () =>
          import(
            /* webpackChunkName: "tenantsCandidatesInfo"  */ '@/views/tenantsCandidatesInfo/index.vue'
          ),
        meta: {
          title: i18n.t('candidates.title').toString(),
          customIcon: 'users.svg',
          layout: 'main-layout',
        },
      },
      {
        name: 'DriverSurcharge',
        path: '/driverSurcharge',
        component: () => import('@/modules/registry/views/RegistryOfSurchargesView.vue'),
        meta: {
          title: 'Реестр по доплатам',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'driverSurcharge',
        },
      },
      {
        name: 'DriverGiveOutAmount',
        path: '/driverGiveOutAmount',
        component: () => import('@/modules/registry/views/RegistryOfGiveOutAmountView.vue'),
        meta: {
          title: 'Реестр по расчетам',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'driverGiveOutAmount',
        },
      },
      {
        name: 'RegistryWithdraw',
        path: '/registryWithdraw',
        component: () => import('@/modules/registry/views/RegistryOfWithdrawView.vue'),
        meta: {
          title: 'Реестр по выплатам',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'registryWithdraw',
        },
      },
      {
        name: 'CashRegister',
        path: '/cashRegister',
        component: () => import('@/modules/registry/views/RegistryOfReadyCashView.vue'),
        meta: {
          title: 'Реестр по наличным',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'cashRegister',
        },
      },
      // {
      //   name: 'OpenTransactions',
      //   path: '/OpenTransactions',
      //   component: () => import(/* webpackChunkName: "tenantsCandidatesInfo"  */ '@/views/OpenTransactions/index.vue'),
      //   meta: {
      //     title: 'Реестр должников',
      //     icon: ['fas', 'list'],
      //     layout: 'main-layout'
      //   }
      // },
      {
        name: 'OpenTransactionsDebts',
        path: '/OpenTransactionsDebts',
        component: () =>
          import(
            /* webpackChunkName: "OpenTransactionsDebts"  */ '@/views/OpenTransactionsDebts/index.vue'
          ),
        meta: {
          title: 'Задолженности по арендаторам',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'openTransactionsDebts',
        },
      },
      {
        name: 'MaintenanceRepair',
        path: '/maintenanceRepair',
        component: () =>
          import(
            /* webpackChunkName: "maintenanceRepair"  */ '@/modules/registry/views/RegistryMaintenanceRepairView.vue'
          ),
        meta: {
          title: i18n.t('maintenance_repair.title').toString(),
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'maintenanceRepair',
        },
      },
      {
        name: 'MaintenanceRepairArchive',
        path: '/maintenanceRepairArchive',
        component: () =>
          import(
            /* webpackChunkName: "maintenanceRepairArchive"  */ '@/modules/registry/views/RegistryMaintenanceRepairView.vue'
          ),
        meta: {
          title: 'Реестр по плану Т.О. и ремонт (legacy)',
          customIcon: 'users.svg',
          layout: 'main-layout',
          devFlag: 'maintenanceRepair',
        },
      },
      {
        path: '/rentalPayment',
        name: 'RentalPayment',
        component: () =>
          import(
            /* webpackChunkName: "carPark"  */ '@/modules/registry/views/RegistryVehicleRentalPaymentView.vue'
          ),
        meta: {
          title: 'Реестр уплаты арендной платы',
          icon: ['fas', 'taxi'],
          layout: 'main-layout',
          devFlag: 'rentalPayment',
        },
      },
      {
        path: '/driverBalanceChanges',
        name: 'driverBalanceChanges',
        component: () =>
          import(
            /* webpackChunkName: "carPark"  */ '@/modules/registry/views/RegistryDriverBalanceChangesView.vue'
          ),
        meta: {
          title: 'Реестр изменений балансов водителей',
          icon: ['fas', 'taxi'],
          layout: 'main-layout',
          devFlag: 'driverBalanceChanges',
        },
      },
    ],
  },
  {
    path: '',
    name: 'Cars',
    meta: {
      title: i18n.t('car_park.title').toString(),
      icon: ['fas', 'taxi'],
      layout: 'main-layout',
    },
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    children: [
      {
        path: '/cars/carpark',
        name: 'CarPark',
        component: () =>
          import(/* webpackChunkName: "carPark"  */ '@/modules/carParks/views/CarParkPage.vue'),
        meta: {
          title: i18n.t('car_park.title').toString(),
          icon: ['fas', 'taxi'],
          layout: 'main-layout',
          devFlag: 'carpark',
        },
      },
      {
        path: '/cars/carFund',
        name: 'CarFund',
        component: () =>
          import(
            /* webpackChunkName: "carPark"  */ '@/modules/registry/views/RegistryCarFundView.vue'
          ),
        meta: {
          title: 'Реестр по фонду новых авто',
          icon: ['fas', 'taxi'],
          layout: 'main-layout',
          devFlag: 'carFund',
        },
      },
    ],
  },
  // {
  //   path: '/carpark',
  //   name: 'CarPark',
  //   component: () => import(/* webpackChunkName: "carPark"  */ '@/modules/carParks/views/CarParkPage.vue'),
  //   meta: {
  //     title: 'Автопарк',
  //     icon: ['fas', 'taxi'],
  //     layout: 'main-layout',
  //     devFlag: 'carpark'
  //   }
  // },
  {
    path: '/localCarPark',
    name: 'localCarPark',
    component: () =>
      import(
        /* webpackChunkName: "localCarLocalParks"  */ '@/modules/localParks/views/LocalParksPage.vue'
      ),
    meta: {
      title: 'Парки',
      customIcon: 'user_mic.svg',
      layout: 'main-layout',
      devFlag: 'localCarPark',
    },
  },
  {
    path: '/localCarParkOld',
    name: 'localCarParkOld',
    component: () =>
      import(
        /* webpackChunkName: "deprecatedLocalCarLocalParks"  */ '@/views/carLocalParks/index.vue'
      ),
    meta: {
      title: 'Парки стари',
      customIcon: 'user_mic.svg',
      layout: 'main-layout',
    },
  },
  {
    path: '',
    name: 'contracts.redirect',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      title: 'Договоры',
      customIcon: 'document.svg',
      layout: 'main-layout',
    },
    children: [
      {
        path: '/contracts',
        name: 'Contracts',
        //   component: () => import(/* webpackChunkName: "contracts"  */ '@/views/contracts.vue'),
        component: () =>
          import(
            /* webpackChunkName: "contracts"  */ '@/modules/contracts/views/ContractsView.vue'
          ),
        meta: {
          title: 'Договоры',
          customIcon: 'document.svg',
          layout: 'main-layout',
          devFlag: 'contracts',
          // visible: false
        },
      },
    ],
  },
  {
    path: '',
    name: 'investors.redirect',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      title: 'Собственники авто ',
      customIcon: 'user.svg',
      layout: 'main-layout',
    },
    children: [
      {
        path: '/investors',
        name: 'Investors',
        //   component: () => import(/* webpackChunkName: "investors"  */ '@/views/investors.vue'),
        component: () =>
          import(
            /* webpackChunkName: "investors"  */ '@/modules/investors/views/InvestorsView.vue'
          ),
        meta: {
          title: 'Собственники авто',
          customIcon: 'user.svg',
          layout: 'main-layout',
          devFlag: 'investors',
        },
      },
    ],
  },
  {
    path: '',
    name: 'techInspection.redirect',
    meta: {
      title: 'Т.О',
      customIcon: 'car_repair.svg',
      layout: 'mainLayout',
    },
    component: () =>
      import(/* webpackChunkName: "techInspection"  */ '@/views/techInspection/index.vue'),
    children: [
      {
        path: '/techInspectionRequests',
        name: 'techInspection.requests',
        meta: {
          title: 'Т.О Заявки',
          customIcon: 'car_repair.svg',
          layout: 'mainLayout',
          devFlag: 'techInspectionRequests',
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/views/techInspection/ServiceRequests.vue'
          ),
      },
      {
        path: '/repairs',
        name: 'techInspection.repairs',
        meta: {
          title: 'Т.О Ремонты',
          customIcon: 'car_repair.svg',
          layout: 'mainLayout',
          devFlag: 'techInspectionRepairs',
        },
        component: () =>
          import(
            /* webpackChunkName: "CurrentRepairs"  */ '@/views/techInspection/CurrentRepairs.vue'
          ),
      },
      {
        path: '/history',
        name: 'techInspection.history',
        meta: {
          title: 'Т.О История',
          customIcon: 'car_repair.svg',
          layout: 'mainLayout',
          devFlag: 'techInspectionHistory',
        },
        component: () =>
          import(/* webpackChunkName: "History"  */ '@/views/techInspection/History.vue'),
      },
    ],
  },
  {
    path: '',
    name: 'Parts',
    meta: {
      title: 'Склад',
      customIcon: 'warehouse.svg',
      layout: 'mainLayout',
      allowedRouts: [
        'parts.providers-table',
        'parts.categories-table',
        'parts.parts-table',
        'parts.storage-table',
      ],
    },
    component: () => import(/* webpackChunkName: "parts"  */ '@/views/parts/index.vue'),
    children: [
      {
        path: '/transfer-history-list',
        name: 'parts.transfer-history-list',
        meta: {
          title: 'Склад | История перемещений',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsTransferHistoryList',
          visible: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransferHistoryList.vue'
          ),
      },
      {
        path: '/orders',
        name: 'parts.orders-table',
        meta: {
          title: 'Склад | Заказы',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsOrdersTable',
          visible: false,
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/ordersTable.vue'),
      },
      {
        path: '/providers',
        name: 'parts.providers-table',
        meta: {
          title: 'Склад | Поставщики',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsProvider',
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartProvidersTable.vue'
          ),
      },
      {
        path: '/storage',
        name: 'parts.storage-table',
        meta: {
          title: 'Склад | Склад',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsStorage',
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/StorageTable.vue'),
      },
      {
        path: '/categories',
        name: 'parts.categories-table',
        meta: {
          title: 'Склад | Категории',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsCategories',
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartsCategoriesTable.vue'
          ),
      },
      {
        path: '/parts',
        name: 'parts.parts-table',
        meta: {
          title: 'Склад | Запчасти',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'parts',
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/PartsTable.vue'),
      },
      {
        path: '/items',
        name: 'parts.items-table',
        meta: {
          title: 'Склад | Позиции',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsItems',
          visible: false,
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/components/parts/ItemsTable.vue'),
      },
      {
        path: '/transfers-requests',
        name: 'parts.transfer-requests',
        meta: {
          title: 'Склад | Заявки на перемещение',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsTransferRequests',
          visible: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransfersRequestsTable.vue'
          ),
      },
      {
        path: '/transfers-requests/:id',
        name: 'parts.transfer-requests.id',
        meta: {
          title: 'Склад | Перемещение позиции по складам',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsTransferRequests',
          visible: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/TransfersRequestsTableById.vue'
          ),
      },
      {
        path: '/decommission',
        name: 'parts.decommission',
        meta: {
          title: 'Склад | Списания',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsDecommission',
          visible: false,
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/parts/decommission.vue'),
      },
      {
        path: '/decommission/act/:id',
        name: 'parts.decommission.act',
        meta: {
          title: 'Склад | Акт списания детализированный',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsDecommission',
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/actTable.vue'
          ),
      },
      {
        path: '/decommission/movement/history',
        name: 'parts.decommission.movement.history',
        meta: {
          title: 'Склад | Движение по складу',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsDecommissionMovement',
          visible: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/movementHistory.vue'
          ),
      },
      {
        path: '/decommission/movement/history/details/:id',
        name: 'parts.decommission.movement.history.details',
        meta: {
          title: 'Склад | Детализированное движение по складу',
          customIcon: 'warehouse.svg',
          layout: 'mainLayout',
          devFlag: 'partsDecommissionMovement',
          visible: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "serviceRequests"  */ '@/components/parts/decommission/movementHistoryDetails.vue'
          ),
      },

      // {
      //   path: 'decommission',
      //   meta: {
      //     icon: ['fas', 'user-cog'],
      //     layout: 'mainLayout'
      //   },
      //   redirect: { name: 'parts.decommission' },
      //   component: () => import(/* webpackChunkName: "partsDecommission"  */ '@/views/parts/decommission.vue'),
      //   children: [
      //     {
      //       path: '/',
      //       name: 'parts.decommission',
      //       meta: {
      //         title: 'Запчасти | Списания',
      //         icon: ['fas', 'user-cog'],
      //         layout: 'mainLayout'
      //       },
      //       component: () => import(/* webpackChunkName: "partsDecommissionTable"  */ '@/components/parts/decommission/table.vue')
      //     },
      //     {
      //       path: 'act',
      //       name: 'parts.decommission.act',
      //       meta: {
      //         title: 'Запчасти | Акт списания',
      //         icon: ['fas', 'user-cog'],
      //         layout: 'mainLayout'
      //       },
      //       component: () => import(/* webpackChunkName: "actTable"  */ '@/components/parts/decommission/actTable.vue')
      //     }
      //   ]
      // }
    ],
  },
  {
    path: '',
    name: 'fines.layout',
    // redirect: { name: 'parts.storage-table' },
    // component: () => import(/* webpackChunkName: "parts"  */ '@/views/fines/layout.vue'),
    component: () =>
      import(/* webpackChunkName: "parts"  */ '@/modules/fines/views/FinesLayout.vue'),
    meta: {
      title: 'Штрафы',
      customIcon: 'cvtv.svg',
      layout: 'mainLayout',
    },
    children: [
      {
        path: '/fines',
        name: 'fines',
        meta: {
          title: 'Штрафы',
          customIcon: 'cvtv.svg',
          layout: 'mainLayout',
          devFlag: 'fines',
        },
        component: () =>
          import(/* webpackChunkName: "FinesView"  */ '@/modules/fines/views/FinesView.vue'),
      },
      {
        path: '/fines/history',
        name: 'fines.history',
        meta: {
          title: 'Штрафы | История',
          customIcon: 'cvtv.svg',
          layout: 'mainLayout',
          devFlag: 'finesHistory',
        },
        component: () =>
          import(
            /* webpackChunkName: "FinesHistoryView"  */ '@/modules/fines/views/FinesHistoryView.vue'
          ),
      },
      {
        path: '/fines/archive',
        name: 'fines.archive',
        meta: {
          title: 'Штрафы | Удаленные',
          customIcon: 'cvtv.svg',
          layout: 'mainLayout',
          devFlag: 'finesArchive',
        },
        component: () =>
          import(/* webpackChunkName: "FinesArchive"  */ '@/modules/fines/views/FinesArchive.vue'),
      },
    ],
  },
  {
    path: '/templates/',
    name: 'templates.layout',
    // redirect: { name: 'parts.storage-table' },
    component: () => import(/* webpackChunkName: "parts"  */ '@/views/templates/layout.vue'),
    meta: {
      title: 'ЭДО',
      customIcon: 'cvtv.svg',
      layout: 'mainLayout',
    },
    children: [
      {
        path: ':park_id',
        name: 'templates',
        meta: {
          title: 'ЭДО | Шаблоны',
          icon: ['fas', 'user-cog'],
          visible: false,
          layout: 'mainLayout',
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/index.vue'),
      },
      {
        path: '/templates/:park_id/types',
        name: 'templates.types',
        meta: {
          title: 'ЭДО | Типы',
          icon: ['fas', 'user-cog'],
          visible: false,
          layout: 'mainLayout',
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/types.vue'),
      },
      {
        path: '/templates/:park_id/editor',
        name: 'templates.editor',
        meta: {
          title: 'ЭДО | Документ',
          icon: ['fas', 'user-cog'],
          visible: false,
          layout: 'mainLayout',
        },
        component: () =>
          import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/editor.vue'),
      },
    ],
  },
  {
    path: '/offer',
    name: 'templates.offer',
    meta: {
      title: 'ЭДО | Оферта',
      icon: ['fas', 'user-cog'],
      layout: 'mainLayout',
      devFlag: 'offer',
    },
    component: () =>
      import(
        /* webpackChunkName: "serviceRequests"  */ '@/modules/edmTemplates/views/EdmOfferView.vue'
      ),
    // component: () => import(/* webpackChunkName: "serviceRequests"  */ '@/views/templates/offer.vue')
  },
  {
    path: '/configurator/:settings_id',
    name: 'Configurator',
    component: () =>
      import(/* webpackChunkName: "configurator"  */ '@/views/configurator/index.vue'),
    meta: {
      visible: false,
      title: 'Конфигуратор',
      icon: ['fas', 'sliders-h'],
      layout: 'main-layout',
    },
  },
  {
    path: '/promo',
    component: () =>
      import(/* webpackChunkName: "promoPage"  */ '@/modules/promo/views/PromoPage.vue'),
    name: 'promo',
    meta: {
      title: i18n.t('promo.title').toString(),
      icon: ['fas', 'tag'],
      layout: 'main-layout',
    },
  },
  {
    path: '/agent-reports',
    name: 'agentReports.layout',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      layout: 'main-layout',
      devFlag: 'agentReports',
    },
    children: [
      {
        path: '/agent-reports/all',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentAllReportsView.vue'
          ),
        name: 'agentAllReports',
        meta: {
          title: i18n.t('agents_reports.summary_all.title').toString(),
          icon: AppFaIcons.tableList,
          layout: 'main-layout',
          devFlag: 'agentReports',
        },
      },
      {
        path: '/agent-reports/each',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentEachReportsView.vue'
          ),
        name: 'agentEachReports',
        meta: {
          title: i18n.t('agents_reports.individual_each.title').toString(),
          icon: AppFaIcons.tableList,
          layout: 'main-layout',
          devFlag: 'agentReports',
        },
      },
      {
        path: '/agent-reports/director',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentDirectorReportsView.vue'
          ),
        name: 'agentDirectorReports',
        meta: {
          title: i18n.t('agents_reports.detailed_director.title').toString(),
          icon: AppFaIcons.tableList,
          layout: 'main-layout',
          devFlag: 'agentReports',
        },
      },
      {
        path: '/agent-reports/manager',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentManagerReportsView.vue'
          ),
        name: 'agentManagerReports',
        meta: {
          title: i18n.t('agents_reports.payments_manager.title').toString(),
          icon: AppFaIcons.tableList,
          layout: 'main-layout',
          devFlag: 'agentReports',
        },
      },
      {
        path: '/agent-reports/template-editor',
        component: () =>
          import(
            /* webpackChunkName: "agentReportTemplateEditorPage"  */ '@/modules/agentReports/views/AgentReportTemplateEditorView.vue'
          ),
        name: 'agentReportsTemplateEditor',
        meta: {
          visible: false,
          title: i18n.t('agents_reports.template_editor.title').toString(),
          layout: 'main-layout',
          devFlag: 'agentReports',
        },
      },
    ],
  },
  {
    path: '/agent-reports/serbia',
    component: () =>
      import(
        /* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentSerbiaReportsView.vue'
      ),
    name: 'agentSerbiaReports',
    meta: {
      title: 'Отчет для Сербии',
      icon: AppFaIcons.tableList,
      layout: 'main-layout',
      parkMode: ParkMode.SERBIA,
      devFlag: 'agentReports',
    },
  },
  {
    path: '',
    name: 'driversOffer.layout',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    meta: {
      layout: 'main-layout',
      devFlag: 'driversOffer',
    },
    children: [
      {
        path: '/drivers-offer',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/driversOffer/views/DriversOfferView.vue'
          ),
        name: 'driversOffer',
        meta: {
          title: i18n.t('driver_offer.offer_title').toString(),
          icon: AppFaIcons.fileSignature,
          layout: 'main-layout',
          devFlag: 'driversOffer',
        },
      },
      {
        path: '/drivers-offer/reports',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/driversOffer/views/OfferReportsView.vue'
          ),
        name: 'driversOfferReports',
        meta: {
          title: i18n.t('driver_offer.reports.title').toString(),
          icon: AppFaIcons.fileSignature,
          layout: 'main-layout',
          devFlag: 'driversOffer',
        },
      },
      {
        path: '/drivers-offer/template-editor',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/driversOffer/views/DriversOfferTemplateEditorView.vue'
          ),
        name: 'driversOfferTemplateEditor',
        meta: {
          title: i18n.t('driver_offer.template_editor_title').toString(),
          icon: AppFaIcons.fileSignature,
          layout: 'main-layout',
          devFlag: 'driversOffer',
        },
      },
      {
        path: '/drivers-offer/body-editor',
        component: () =>
          import(
            /* webpackChunkName: "agentReportsPage"  */ '@/modules/driversOffer/views/DriversOfferBodyEditorView.vue'
          ),
        name: 'driversOfferBodyEditor',
        meta: {
          title: i18n.t('driver_offer.template_editor_title').toString(),
          icon: AppFaIcons.fileSignature,
          layout: 'main-layout',
          devFlag: 'driversOffer',
        },
      },
    ],
  },
  // {
  //   path: '/agent-reports',
  //   component: () => import(/* webpackChunkName: "agentReportsPage"  */ '@/modules/agentReports/views/AgentReportsView.vue'),
  //   name: 'agentReports',
  //   meta: {
  //     title: 'Отчеты агента',
  //     icon: AppFaIcons.tableList,
  //     layout: 'main-layout'
  //   }
  // },
  // {
  //   path: '/agent-reports/template-editor',
  //   component: () => import(/* webpackChunkName: "agentReportTemplateEditorPage"  */ '@/modules/agentReports/views/AgentReportTemplateEditorView.vue'),
  //   name: 'agentReportsTemplateEditor',
  //   meta: {
  //     visible: false,
  //     title: 'Редактор шаблона отчета агента',
  //     layout: 'main-layout'
  //   }
  // },
  {
    path: '/promo/:id',
    component: () =>
      import(/* webpackChunkName: "promoStatsPage"  */ '@/modules/promo/views/PromoStats.vue'),
    name: 'promo.stats',
    meta: {
      title: i18n.t('promo.promo_stats_title').toString(),
      visible: false,
      layout: 'main-layout',
    },
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "emptyLayout"  */ '@/layouts/emptyLayout.vue'),
    redirect: { name: 'CRMV2' },
    name: 'settings.crmV2',
    meta: {
      title: 'Параметры',
      icon: ['fas', 'sliders-h'],
      layout: 'main-layout',
    },
    children: [
      {
        path: '/drivers-app-settings',
        name: 'DriversAppSettings',
        component: () =>
          import(
            /* webpackChunkName: "driversAppSettings"  */ '@/modules/driversAppSettings/views/DriversAppSettingsView.vue'
          ),
        meta: {
          title: i18n.t('drivers_app.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
        },
      },
      {
        path: '/work-rules-settings',
        name: 'WorkRulesSettings',
        component: () =>
          import(
            /* webpackChunkName: "workRulesSettings"  */ '@/modules/workRules/views/WorkRulesView.vue'
          ),
        meta: {
          title: 'Условия работы',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'workRulesSettings',
        },
      },
      {
        path: '/admins',
        name: 'Admins',
        component: () => import(/* webpackChunkName: "admins"  */ '@/views/admins/index.vue'),
        meta: {
          title: i18n.t('admins.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
        },
      },
      {
        path: '/logs',
        name: 'Logs',
        component: () =>
          import(/* webpackChunkName: "logs"  */ '@/modules/logs/views/LogsView.vue'),
        // component: () => import(/* webpackChunkName: "logs"  */ '@/views/admins/logs.vue'),
        meta: {
          title: i18n.t('logs.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
        },
      },
      {
        path: '/roles',
        name: 'Roles',
        component: () => import(/* webpackChunkName: "roles"  */ '@/views/roles/index.vue'),
        meta: {
          title: i18n.t('roles.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
        },
      },
      {
        path: '/crm',
        name: 'CRM',
        component: () => import(/* webpackChunkName: "crm"  */ '@/views/crm/index.vue'),
        meta: {
          title: 'Настройки CRM',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
        },
      },
      {
        path: '/crmV2',
        name: 'CRMV2',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/crmSettings/views/crmParkSettingsPage.vue'
          ),
        meta: {
          title: i18n.t('crm_settings.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'settingsCrmV2',
        },
      },
      {
        path: '/notify',
        name: 'notify.layout',
        component: () =>
          import(
            /* webpackChunkName: "fiscalReceipts"  */ '@/modules/notifySettings/views/NotifyLayout.vue'
          ),
        meta: {
          layout: 'main-layout',
          title: 'Уведомления',
          visible: false,
        },
        children: [
          {
            path: '/notify/appeal',
            name: 'Notify',
            meta: {
              icon: ['fas', 'question'],
              layout: 'mainLayout',
              devFlag: 'notify',
              title: 'Обращение в тех. поддержку',
            },
            component: () =>
              import(
                /* webpackChunkName: "notify"  */ '@/modules/notifySettings/views/NotifyView.vue'
              ),
          },
          {
            path: '/notify/settings',
            name: 'NotifySettings',
            meta: {
              title: 'Настройки уведомлений',
              icon: ['fas', 'question'],
              layout: 'mainLayout',
              devFlag: 'notifySettings',
            },
            component: () =>
              import(
                /* webpackChunkName: "notify-settings"  */ '@/modules/notifySettings/views/NotifySettingsView.vue'
              ),
          },
        ],
      },
      {
        path: '/globalParkSettings',
        name: 'globalParkSettings',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/crmParkSettingss/views/CrmSettingsPage.vue'
          ),
        meta: {
          title: i18n.t('global_settings.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'globalParkSettingsV2',
        },
      },
      {
        path: '/edm',
        name: 'EDMSettings',
        component: () =>
          import(/* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/EdmSettingsView.vue'),
        meta: {
          title: 'Настройки ЭДО',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'edmSettings',
        },
      },
      {
        path: '/edm/fine-payment-template-editor',
        name: 'finePaymentTemplateEditor',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/FinePaymentTemplateView.vue'
          ),
        meta: {
          title: 'Шаблон платежного документа',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          visible: false,
        },
      },
      {
        path: '/edm/fine-payment-wrapper-template-editor',
        name: 'finePaymentWrapperTemplateEditor',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/edmSettings/views/FinePaymentWrapperTemplateView.vue'
          ),
        meta: {
          title: 'Обертка платежного документа',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          visible: false,
        },
      },
      {
        path: '/techInspection/settings',
        name: 'TechInspectionSettings',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/techInspectionSettings/views/MaintenanceSettingsPage.vue'
          ),
        meta: {
          title: 'Настройки ТО',
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'techInspectionSettings',
        },
      },
      {
        path: '/crm/keys',
        name: 'CRM.keys',
        component: () =>
          import(
            /* webpackChunkName: "crm"  */ '@/modules/crmKeysSettings/views/CrmKeysSettingsView.vue'
          ),
        meta: {
          title: i18n.t('crm_keys.title').toString(),
          icon: ['fas', 'sliders-h'],
          layout: 'main-layout',
          devFlag: 'crmKeysSettings',
        },
      },
      {
        path: '/adm-templates',
        name: 'AdmTemplates',
        component: () => import('@/modules/admTemplates/views/AdmTemplatesView.vue'),
        meta: {
          title: i18n.t('adm_templates').toString(),
          icon: ['fas'],
          layout: 'main-layout',
          devFlag: 'admSettings',
        },
      },
    ],
  },
  // {
  //   path: '/notify',
  //   name: 'notify.layout',
  //   component: () => import(/* webpackChunkName: "fiscalReceipts"  */ '@/modules/notifySettings/views/NotifyLayout.vue'),
  //   meta: {
  //     layout: 'main-layout',
  //     title: 'Уведомления',
  //     visible: false
  //   },
  //   children: [
  //     {
  //       path: '/notify/appeal',
  //       name: 'Notify',
  //       meta: {
  //         icon: ['fas', 'question'],
  //         layout: 'mainLayout',
  //         devFlag: 'notify',
  //         title: 'Обращение в тех. поддержку'
  //       },
  //       component: () => import(/* webpackChunkName: "notify"  */ '@/modules/notifySettings/views/NotifyView.vue')
  //     },
  //     {
  //       path: '/notify/settings',
  //       name: 'NotifySettings',
  //       meta: {
  //         title: 'Настройки уведомлений',
  //         icon: ['fas', 'question'],
  //         layout: 'mainLayout',
  //         devFlag: 'notifySettings'
  //       },
  //       component: () => import(/* webpackChunkName: "notify-settings"  */ '@/modules/notifySettings/views/NotifySettingsView.vue')
  //     }
  //   ]
  // },
  {
    path: '/public/offer-sign-widget',
    name: 'offerSignWidget',
    component: () =>
      import(
        /* webpackChunkName: "tenantsIncome"  */ '@/modules/instantPayment/views/OfferSignView.vue'
      ),
    meta: {
      title: 'Принятие условий',
      customIcon: 'coins.svg',
      layout: 'empty-layout',
      devFlag: 'instantPayment',
      visible: false,
    },
  },
  {
    path: '/public/verification-driver-widget',
    name: 'verificationDriverWidget',
    component: () =>
      import(
        /* webpackChunkName: "tenantsIncome"  */ '@/modules/driverVerification/views/VerificationDriverView.vue'
      ),
    meta: {
      title: 'Верификация водителя',
      customIcon: 'coins.svg',
      layout: 'empty-layout',
      devFlag: 'verificationDriver',
      visible: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
    meta: {
      title: 'Авторизация',
      layout: 'empty-layout',
      visible: false,
    },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "registration" */ '@/views/registration.vue'),
    meta: {
      layout: 'empty-layout',
      visible: false,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
